import React from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { homeLayoutContainerStyles } from "styles/homeLayout";
import { minTablet, mobile } from "utils/styles";

const Container = styled.div`
  ${homeLayoutContainerStyles}
  border-top: unset;
  padding: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  height: 100vh;

  ${mobile`
    height: 100vh;
    justify-content: center;
    padding-top: 0;
  `}

  ${minTablet`
    background-color: #ececec;
    height: 100vh;
    position: relative;
  `}
`;
const TopBanner = styled.img`
  width: 100vw;
  ${mobile`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 5;
  `}
  ${minTablet`
    display: none;
  `}
`;
const LogoVertical = styled.img`
  width: 100%;
  max-width: 250px;
  margin-top: -50px;
  ${mobile`
    margin-bottom: 20px;
  `}
  ${minTablet`
    display: none;
  `}
`;
const LogoHorizontal = styled.img`
  width: 500px;
  ${mobile`
    display: none;
  `}
  ${minTablet`
    position: absolute;
    top: 20px;
    left: 50%;
    z-index: 10;
    transform: translateX(-50%);
  `}
`;
const MobileFooterImage = styled.img`
  width: 100%;
  display: none;

  ${mobile`
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  `}
`;
const DesktopFooterImage = styled.img`
  width: 100%;
  ${mobile`
    display: none;
  `}
  ${minTablet`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
  `}
`;
const Wrapper = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 0 20px;
  margin-top: 20px;
  ${mobile`
    margin-top: 0;
  `}
  ${minTablet`
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0;
    z-index: 10;
  `}
`;

export const HomeLayout = ({ children }) => {
  const location = useLocation();
  const isAgreementPage = location.pathname === "/agreement";

  return (
    <Container>
      <TopBanner src="/static/akapbigas/header-patterns.png" />
      {!isAgreementPage && (
        <>
          <LogoVertical src="/static/akapbigas/logo-vertical.svg" />
          <LogoHorizontal src="/static/akapbigas/akap-rice-header-logo.svg" />
        </>
      )}
      <Wrapper>{children}</Wrapper>
      <MobileFooterImage src="/static/akapbigas/logo-footer.svg" />
      <DesktopFooterImage src="/static/akapbigas/logo-footer.svg" />
    </Container>
  );
};
